import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Destination from "./pages/Destination";
import Tours from "./pages/Tours";
import Blogs from "./pages/Blogs";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import DetailedSafariPage from "./pages/DetailSafariPage";
import Loader from "./components/Loader";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Show loader for 2 seconds

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="destinations" element={<Destination />} />
          <Route path="tours" element={<Tours />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<Contact />} />
          <Route path="safari/:id" element={<DetailedSafariPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;